import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { BudgetType } from '../../typings/budget';
import { CurrencyCode, GdCampaignBudgetShowMode } from '../../typings/graphql-grid';
import { RecommendationKey, RecommendationType } from '../../typings/recommendations';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';
import { CampaignDayBudgetInfo } from '../CampaignDayBudgetInfo/CampaignDayBudgetInfo';
import { HoverTooltipWrapper } from '../HoverTooltipWrapper/HoverTooltipWrapper';
import { Shape2, Shape2Icon } from '../Shape2/Shape2';

import './RecommendationBudgetApplyCell.css';
import * as keyset from './RecommendationBudgetApplyCell.i18n';

const i18n = i18nFactory(keyset);

export interface RecommendationBudgetApplyCellProps {
    campaignName: string;
    campaignId: string;
    recommendationKeys: Array<RecommendationKey>;
    currency: CurrencyCode;
    value: number;
    isInProgress: boolean;
    isApplicable: boolean;
    onClick: (type: RecommendationType, keys: Array<RecommendationKey>, id: string, name: string) => void;
}

export class RecommendationBudgetApplyCell extends React.PureComponent<RecommendationBudgetApplyCellProps> {
    render() {
        const { value, isInProgress, isApplicable } = this.props;

        return (
            <div className={Bem.cls('recommendation-budget-apply-cell')}>
                <CampaignDayBudgetInfo
                    value={{
                        type: BudgetType.day,
                        isActive: true,
                        mode: GdCampaignBudgetShowMode.DEFAULT,
                        sum: value
                    }}
                    isCompactViewEnabled={false}
                />

                <div className={Bem.cls('recommendation-budget-apply-cell', 'button-wrapper')}>
                    <ButtonDecorator
                        onClick={this.onApplyButtonClick}
                        cls={Bem.cls('recommendation-budget-apply-cell', 'button')}
                        view="classic"
                        theme="action"
                        size="n"
                        disabled={!isApplicable}
                        progress={isInProgress}
                        text={isInProgress ? i18n('progress-accept-button') : i18n('accept-button')}
                    />

                    {this.getButtonHint()}
                </div>
            </div>
        );
    }

    private getButtonHint = () => {
        const { isApplicable } = this.props;

        if (isApplicable) {
            return null;
        }

        return (
            <HoverTooltipWrapper
                tooltipText={i18n('no-rights')}
                to={['top', 'left']}
                isDoccenterTooltip={false}
                cls={Bem.cls('recommendation-budget-apply-cell', 'hint')}
            >
                <Shape2 width={16} height={16} icon={Shape2Icon.warning} />
            </HoverTooltipWrapper>
        );
    };

    private onApplyButtonClick = () => {
        const { onClick, recommendationKeys, campaignId, campaignName } = this.props;

        onClick(RecommendationType.dailyBudget, recommendationKeys, campaignId, campaignName);
    };
}
